import $ from 'jquery';

import '../bundles/northstar';
import cmsIconFix from '../components/cms-icon-fix';
import hp from '../init/hp';
import hpNav from '../components/hp-nav';
import makeGoodHappen from '../widgets/make-good-happen';
import waitTimes from '../widgets/wait-times';
import planFinder from '../webapps/plan-finder';
import planFinderPrev from '../webapps/plan-finder-prev-year';
import navigationActive from '../utils/navigation-active';
import browserAlert from '../utils/browser-alert';
import siteNavigation from '../webapps/site-navigation';
import logonSpinner from '../components/logon-spinner';

import '@hppl/enterprise-scss/northstar/public/public.scss';
import backToTop from '../webapps/back-to-top';

window.hp = hp();
window.hp.nav = hpNav;

$(document).ready(function() {
  hpNav();
  cmsIconFix();
  makeGoodHappen();
  waitTimes();
  planFinder();
  planFinderPrev();
  siteNavigation($);
  navigationActive();
  browserAlert(window.hp);
  backToTop($);
  logonSpinner();
});



// WEBPACK FOOTER //
// ./src/webpack/bundles/hp.js